const API = process.env.REACT_APP_API_URL;

const headers = (token) => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${token}`,
});

// =========================================================
// CURRENT COMPETITION SURVEY
// =========================================================

export const GetCurrentCompetitionSurvey = async (token) => {
  try {
    const response = await fetch(`${API}/CompetitionSurvey/GetCurrentSurvey`, {
      method: "GET",
      headers: headers(token),
      credentials: "include",
    });

    const text = await response.text();

    let data;

    try {
      data = text ? JSON.parse(text) : null;
    } catch {
      throw new Error("Invalid server response.");
    }

    if (!response.ok) {
      throw new Error(
        data?.message || "Unable to retrieve the current competition survey.",
      );
    }

    return data;
  } catch (error) {
    console.error("GetCurrentCompetitionSurvey error:", error);
    throw error;
  }
};

export const GetCompetitionVisitSummary = async (token, locationId) => {
  const url = `${API}/CompetitionSurvey/GetCompetitionVisitSummary/${locationId}`;

  console.log("Competition Visit Summary URL:", url);
  console.log("Competition Visit Summary locationId:", locationId);
  console.log("Competition Visit Summary token exists:", !!token);

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
    });

    console.log("Competition Visit Summary status:", response.status);

    console.log(
      "Competition Visit Summary content-type:",
      response.headers.get("content-type"),
    );

    if (response.ok) {
      const blob = await response.blob();

      console.log("Competition Visit Summary blob:", blob);

      return {
        success: true,
        blob,
      };
    }

    const responseText = await response.text();

    console.error(
      "Competition Visit Summary API error:",
      response.status,
      responseText,
    );

    return {
      success: false,
      status: response.status,
      error: responseText,
    };
  } catch (error) {
    console.error("Competition Visit Summary fetch error:", error);

    return {
      success: false,
      status: null,
      error: error.message,
    };
  }
};
